import { LayoutRoute, Route } from "@soft-db/typed-router";

const distributorRoutes = new LayoutRoute({
	name: "distributor",
	path: "distributor",
	component: () => import("@/pages/distributor.vue"),
	meta: {
		feature: "scopeSettings",
		permission: "distributor.update",
	},
	children: [
		new Route({
			path: ":id",
			component: () => import("@/pages/distributor/index.vue"),
			redirect: { name: "distributor-id-settings" },
			children: [
				new Route({
					path: "settings",
					component: () => import("@/pages/distributor/settings.vue"),
				}),
				new Route({
					path: "users/:userid",
					component: () => import("@/pages/distributor/userid.vue"),
				}),
				new Route({
					path: "public-pages/:pageid",
					component: () => import("@/pages/distributor/public-page-id.vue"),
				}),
			],
		}),
	],
});

export default distributorRoutes;
